import {ServersDashboardState} from './states/servers-dashboard.state';

export const serversDashboardStates = [
    ServersDashboardState
];
